<template>
	<div class="ecology">
		<div class="m-top-box">
			<Nav/>
            <div class="flex-center">
                <img class="u-img" src="https://static.gzldyg.cn/group3/M00/06/1F/CgEyJmHyTv2AQeO8AAAu_MspN_o238.png" alt="">
            </div>
            <h3>城市级本地化数字经济基础设施及运营解决方案提供商</h3>
		</div>
        <div>
            <img src="../assets/images/home2.png" alt="" class="u-bg-img2">
            <img src="../assets/images/home3.png" alt="" class="u-bg-img2" >
            <img src="../assets/images/home4.jpg" alt="" class="u-bg-img2" >
            <img src="../assets/images/home5.png" alt="" class="u-bg-img2" >
        </div>
	</div>
</template>
<style scoped lang="scss">
	.m-top-box{ 
		width: 100%;
		padding-top: 10px;
		background: url(https://static.gzldyg.cn/group3/M00/06/1F/CgEyJmHzi8eAArb7AAYU92X7U78451.png) no-repeat center top;
		background-size:cover; 
        height: 800px;
        justify-content: center;
        padding-bottom: 180px;
        width: 100%;
		h3 {
			color: #fff;
            font-size: 40px;
            font-weight: 500;
            text-align: center;
			height: 100px;
			line-height: 100px;
			margin-top: 120px;
			margin-bottom: 60px;
		}
        .flex-center{
            margin-top: 270px;
            -ms-flex-pack: center;
            -webkit-box-pack: center;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            justify-content: center;
            width: 100%;
            .u-img{
                width: 76px;
                height: 73px;
            }
        }
	}
    .u-bg-img2{
        display: block;
        width: 100%;
        height: 100%;
        margin: 0px;
        padding: 0px;
    }
    
	.mr24{
		margin-right: 25px;
	}
	.m-dest-list{
		height: 410px;
		li{
			width:288px;
			height: 360px;
			padding: 24px 30px 26px;
			background: #FFFFFF;
			box-shadow: 2px 2px 20px 1px rgba(53,68,120,0.2);
			border-radius: 10px;
		}
		.u-txt-tit{
			font-size: 18px;
			line-height: 26px;
			margin-top: 10px;
			margin-bottom: 10px;
		}
		.u-txt-info{
			text-align: justify;
			text-justify: inter-ideograph;/*IE*/
		}
	}
	.m-character-list{
		width: 1200px;
		overflow: hidden;
		dl{
			width: 200px;
			margin-right: 100px;
			dt{
				line-height: 0;
			}
			.dt1{
				margin-bottom: 8px;
			}
			.dt2{
				margin-bottom: 8px;
			}
			.dt3{
				margin-bottom: 19px;
			}
			.dt4{
				margin-bottom: 12px;
			}
			dd{
				text-align: justify;
				text-justify: inter-ideograph;/*IE*/
			}
		}
	}
 </style>
<script>
import Nav from '@/components/Nav.vue'
export default {
  name:'Index',
  components: {
    Nav
  }
}
</script>